const navLinks = [
  { href: '/', label: 'Home' },
  { href: '/plans', label: 'Planos' },
  { href: '/', label: 'Funções' },
  { href: '/control-time', label: 'Controle de Tempo' },
  { href: '/contact', label: 'Contato' },
  { href: '/trial-test', label: 'Teste Gratuito' },
];

export default navLinks;
